import React, { useCallback } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { NewReleases } from '@mui/icons-material';

interface Props {
  required: boolean;
  style?: React.CSSProperties;
  onChange: (required: boolean) => void;
}

const OptionalMandatoryChooser: React.FC<Props> = ({ required, onChange, ...props }) => {
  const handleOnChange = useCallback(() => {
    onChange(!required);
  }, [onChange, required]);

  const color = required ? 'primary' : 'disabled';
  const tooltip = required ? 'Mandatory' : 'Optional';

  return (
    <Tooltip title={`${tooltip} field`} placement="left">
      <IconButton aria-label="optional-mandatory" onClick={handleOnChange} {...props}>
        <NewReleases fontSize="small" color={color} />
      </IconButton>
    </Tooltip>
  );
};

export default OptionalMandatoryChooser;
